import { render, staticRenderFns } from "./StepFour.vue?vue&type=template&id=04f5de74&scoped=true&"
import script from "./StepFour.vue?vue&type=script&lang=js&"
export * from "./StepFour.vue?vue&type=script&lang=js&"
import style0 from "./StepFour.vue?vue&type=style&index=0&id=04f5de74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f5de74",
  null
  
)

export default component.exports